module.exports = __webpack_public_path__ + "media/images/flags/4x3/afg-03412c91e38b0d44d0a20cebbd40d23c.svg";